export const toggleSearch = data => {
  return {
    type: 'TOGGLE_SEARCH',
    info: 'Open and close the search bar',
    payload: data
  }
}
